(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["trials.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"image-cards is-multiline is-desktop is-margin-bottom-3\">\n\n    ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "trials"))) {
output += "\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "trials");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("trial", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n    <div class=\"image-card ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"cardClass"), env.opts.autoescape);
output += "\">\n        <div class=\"image-card-body\">\n            <p><span class=\"tag is-secondary is-uppercase\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_4),"category")), env.opts.autoescape);
output += "</span></p>\n            <p><a class=\"card-link\" href=\"/clinical-trials/trial/";
output += runtime.suppressValue(runtime.memberLookup((t_4),"nct_id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "</a></p>\n            <p class=\"image-card-body-meta\"><svg class=\"svg-inline--fa fa-calendar-alt fa-w-14\" aria-hidden=\"true\" data-prefix=\"far\" data-icon=\"calendar-alt\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" data-fa-i2svg=\"\"><path fill=\"currentColor\" d=\"M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z\"></path></svg><!-- <i class=\"far fa-calendar-alt\"></i> --><span class=\"meta\">Starting 04/01/2019</span><svg class=\"svg-inline--fa fa-check-square fa-w-14\" aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"check-square\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" data-fa-i2svg=\"\"><path fill=\"currentColor\" d=\"M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z\"></path></svg><!-- <i class=\"fas fa-check-square\"></i> --><span class=\"meta\">Recruiting</span></p>\n            <p class=\"content-excerpt\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_4),"summary")), env.opts.autoescape);
output += "</p>      \n        </div>\n        <div class=\"image-card-foot\">\n            <p><a class=\"button is-link is-regular  is-outlined is-margin-right-1 is-scroll-to\" href=\"/clinical-trials/trial/";
output += runtime.suppressValue(runtime.memberLookup((t_4),"nct_id"), env.opts.autoescape);
output += "\" style=\"font-size:1rem;\">View trial.</a></p>  \n        </div>\n    </div>\n\n    ";
;
}
}
frame = frame.pop();
output += "\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

